import { MutableRefObject } from 'react';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { MetricOption } from 'modules/experiments/types';
import { Skeleton } from 'ui/skeleton';

import { PerformanceHeader, PerformanceHeaderTitle } from './Styled';
import { HeaderMetricSection } from './HeaderMetricSection';

type CardHeaderProps = {
  loading: boolean;
  chartRef: MutableRefObject<any>;
  options: MetricOption<string>[];
};

export const CardHeader = ({ loading, chartRef, options }: CardHeaderProps) => {
  const { t } = useExperimentsTranslations();

  return (
    <PerformanceHeader>
      <PerformanceHeaderTitle>{t('cardHeading.variantPerformance')}</PerformanceHeaderTitle>

      {loading ? (
        <Skeleton width={200} height={38} />
      ) : (
        <HeaderMetricSection chartRef={chartRef} options={options} />
      )}
    </PerformanceHeader>
  );
};
